export enum ApiErrorCode {
  EmailAlreadyUsed = 'email_already_used',
  ValidationError = 'validation_error',
  FederatedEmailDomain = 'federated_email_domain',
  CannotChangeDueTo24HrsLimit = 'cannot_change_email_due_to_24_hrs_limit',
}

export interface ApiError {
  response: Response;
  message: string;
  error_code: ApiErrorCode;
}
